import { configureStore } from '@reduxjs/toolkit'

import MainReducer from './reducer'

export const Store=configureStore({
    reducer:MainReducer
})